import { RootState } from "@/redux/store";

export const qrTemplatesSelector = (state: RootState) => state.qr.templates;
